module.exports = __webpack_public_path__ + "media/images/lb/633-4c5b01491e8b691801f2dabddea4ec33.svg";